import { postJSON } from "@whatslly/commons/apiUtils";
import type { OmittedEventParamsType } from "@whatslly/types/analytics-producer/EventParams";
import { ChunkedQueue } from "@whatslly/commons/chunkedQueue";
import { container } from "./index";
import { FrontLogger } from "@whatslly/commons/frontLogger/frontLogger";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
let disabled = false;
let localFailures = 0;
function handleFailure() {
  const logger = container.get(FrontLogger).getLogger("analytics");
  if (!import.meta.env.PROD) {
    localFailures++;
  }
  if (localFailures > 10) {
    logger.warn("Analytics producer is down, disabling analytics");
    disabled = true;
  }
}

export const analyticsQueue = new ChunkedQueue<OmittedEventParamsType>(
  async (items) => {
    const logger = container.get(FrontLogger).getLogger("analytics");
    const userStore = container.get<IUserStore>(InjectUserStore);
    if (disabled) {
      return;
    }
    try {
      const pod = import.meta.env.VITE_API_DEFAULT_ANALYTICS_POD?.toString() ?? "";
      const etoken = userStore.etoken;
      await postJSON({
        body: JSON.stringify(items),
        pod,
        etoken,
        urlSuffix: "/analytics-producer/batch",
      });
    } catch (err) {
      handleFailure();
      logger.error({ err }, "failed to send chunk to analytics server");
    }
  },
  {
    chunkSize: 50,
    interval: 5000,
  }
);

export const trackEvent = async (data: OmittedEventParamsType & { schemaContent: { phone?: string } }) => {
  const userStore = container.get<IUserStore>(InjectUserStore);
  const user = userStore.user;
  if (!user?.trackAnalytics) {
    return;
  }
  data.schemaContent = {
    ...data.schemaContent,
    platform: "platform.tuvis.com",
  };
  await analyticsQueue.enqueue(data);
};
